export default __webpack_public_path__ + "static/cloud-tec-56c409e3526bc7a07f7319445ef3a8db.png";